
import { Component, Vue } from 'vue-property-decorator'
import { getEmptyBucketRecordPage } from '@/api/record'
import UserNameRemark from '@/components/UserNameRemark/index.vue'

@Component({ name: 'EmptyBucketRecord', components: { UserNameRemark } })
export default class extends Vue {
  private loading = false
  private list: any[] = []
  private total = 0
  private query = { pageNum: 1, pageSize: 10, userPhone: '', orderNumber: '' }

  mounted() { this.loadList() }

  private formatOrderStatus(status: number) {
    const map: Record<number, string> = {
      1: '待付款',
      2: '待接单',
      3: '待派送',
      4: '派送中',
      5: '已完成',
      6: '已取消',
      7: '已退款',
    }
    return map[Number(status)] || '—'
  }

  private orderStatusTagType(status: number) {
    const s = Number(status)
    if (s === 5) return 'success'
    if (s === 7) return 'danger'
    if (s === 6) return 'info'
    if (s === 4) return 'warning'
    if (s === 2 || s === 3) return ''
    return 'info'
  }

  private tableRowClassName({ row }: { row: any }) {
    return Number(row && row.orderStatus) === 7 ? 'row-refunded' : ''
  }

  /** 与订单空桶意图一致：押N桶（¥xx.xx）/ — */
  private formatDeposit(row: any) {
    const qty = Math.max(0, Number(row && row.depositQty) || 0)
    if (qty <= 0) return '—'
    const amt = Number(row && row.depositAmount)
    if (Number.isFinite(amt) && amt > 0) {
      return `押${qty}桶（¥${amt.toFixed(2)}）`
    }
    return `押${qty}桶`
  }

  private async loadList() {
    this.loading = true
    try {
      const params: any = { pageNum: this.query.pageNum, pageSize: this.query.pageSize }
      if (this.query.userPhone) params.userPhone = this.query.userPhone.trim()
      if (this.query.orderNumber) params.orderNumber = this.query.orderNumber.trim()
      const res: any = await getEmptyBucketRecordPage(params)
      if (String(res.data.code) === '1' && res.data.data) {
        this.list = res.data.data.records || []
        this.total = res.data.data.total || 0
      } else {
        this.list = []
        this.total = 0
      }
    } finally {
      this.loading = false
    }
  }

  private handleSearch() { this.query.pageNum = 1; this.loadList() }
  private handleReset() {
    this.query = { pageNum: 1, pageSize: 10, userPhone: '', orderNumber: '' }
    this.loadList()
  }
}
